var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _g, _path106, _path107, _path108, _path109, _g2, _path110, _path111, _path112, _path113, _path114, _g3, _path115, _g4, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 307,
    viewBox: "0 0 393 307",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M389.592 208.469C389.592 208.469 408.606 107.919 356.815 50.9131C311.097 0.557397 238.742 -18.986 179.725 22.5756C158.745 37.4055 143.396 66.2153 118.837 75.1132C91.3023 85.0975 55.9088 88.6963 30.3389 131.448C4.76911 174.2 13.9505 229.146 48.0404 258.39C82.1304 287.635 141.79 259.099 195.546 256.964C249.302 254.829 361.405 332.55 389.592 208.469Z",
    fill: "#0DA06E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M389.592 208.469C389.592 208.469 408.606 107.919 356.815 50.9131C311.097 0.557397 238.742 -18.986 179.725 22.5756C158.745 37.4055 143.396 66.2153 118.837 75.1132C91.3023 85.0975 55.9088 88.6963 30.3389 131.448C4.76911 174.2 13.9505 229.146 48.0404 258.39C82.1304 287.635 141.79 259.099 195.546 256.964C249.302 254.829 361.405 332.55 389.592 208.469Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M204.463 56.5811H264.444V73.6402H204.463C203.178 73.6402 201.945 73.1297 201.036 72.2209C200.128 71.3122 199.617 70.0797 199.617 68.7945V61.4173C199.62 60.1338 200.131 58.9037 201.04 57.997C201.948 57.0903 203.179 56.5811 204.463 56.5811Z",
    fill: "#0DA06E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M264.444 35.2998H208.147C205.892 35.2998 203.73 36.1955 202.135 37.7898C200.541 39.384 199.646 41.5464 199.646 43.801C199.646 46.0557 200.541 48.218 202.135 49.8123C203.73 51.4066 205.892 52.3023 208.147 52.3023H264.444V35.2998Z",
    fill: "#0DA06E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M290.032 15.6807H269.562V72.8279H290.032V15.6807Z",
    fill: "#0DA06E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.621 15.6807H295.152V72.8279H315.621V15.6807Z",
    fill: "#0DA06E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M341.209 15.6807H320.74V72.8279H341.209V15.6807Z",
    fill: "#0DA06E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M204.463 56.5811H264.444V73.6402H204.463C203.178 73.6402 201.945 73.1297 201.036 72.2209C200.128 71.3122 199.617 70.0797 199.617 68.7945V61.4173C199.62 60.1338 200.131 58.9037 201.04 57.997C201.948 57.0903 203.179 56.5811 204.463 56.5811Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M264.444 35.2998H208.147C205.892 35.2998 203.73 36.1955 202.135 37.7898C200.541 39.384 199.646 41.5464 199.646 43.801C199.646 46.0557 200.541 48.218 202.135 49.8123C203.73 51.4066 205.892 52.3023 208.147 52.3023H264.444V35.2998Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M290.032 15.6807H269.562V72.8279H290.032V15.6807Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M315.621 15.6807H295.152V72.8279H315.621V15.6807Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M341.209 15.6807H320.74V72.8279H341.209V15.6807Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M353.574 74.3584H192.825V83.8798H205.87V107.494H213.634V83.8798H328.977V107.494H336.742V83.8798H353.574V74.3584Z",
    fill: "#0DA06E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M353.574 74.3584H192.825V83.8798H205.87V107.494H213.634V83.8798H328.977V107.494H336.742V83.8798H353.574V74.3584Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M161.578 102.696C159.749 103.29 157.954 103.987 156.204 104.783C157.148 104.075 158.093 103.357 159.037 102.611C163.308 99.191 167.367 95.5162 171.194 91.6062C166.691 95.9757 161.88 100.016 156.799 103.697C157.495 102.479 158.11 101.217 158.641 99.9185C159.585 97.5382 159.765 95.1956 157.488 93.8638C154.654 92.2958 151.301 94.6478 152.198 98.6811C152.734 100.919 153.789 103 155.278 104.755C151.976 107.045 148.528 109.115 144.954 110.951L144.613 111.121C145.369 109.814 146.035 108.457 146.607 107.06C147.551 104.679 147.74 102.289 145.464 101.005C142.63 99.4273 139.267 101.779 140.174 105.822C140.702 108.032 141.737 110.089 143.197 111.83C138.899 113.946 134.459 115.74 130.039 117.696L129.396 117.988C130.26 117.059 131.061 116.075 131.796 115.041C133.231 112.935 134.006 110.658 132.088 108.883C129.736 106.701 125.882 108.203 125.816 112.34C125.821 114.634 126.354 116.897 127.375 118.952C123.245 120.866 119.32 123.195 115.662 125.904L115.549 125.989C116.049 125.208 116.5 124.398 116.899 123.561C117.986 121.257 118.382 118.838 116.21 117.441C115.767 117.133 115.26 116.93 114.727 116.847C114.194 116.765 113.649 116.804 113.134 116.964C112.619 117.123 112.146 117.398 111.753 117.767C111.36 118.136 111.055 118.589 110.864 119.094C110.58 118.641 110.187 118.267 109.721 118.007C107.529 116.742 105.376 118.111 103.534 120.048C103.052 120.548 102.589 121.087 102.164 121.634C103.592 117.676 105.385 113.859 107.52 110.233C109.547 111.129 111.736 111.599 113.952 111.612C118.316 111.612 120.158 107.976 118.014 105.718C116.276 103.886 113.82 104.585 111.506 105.917C110.741 106.361 109.995 106.861 109.296 107.371C111.523 104.029 114.052 100.899 116.852 98.0199C118.677 99.4944 120.796 100.561 123.068 101.146C127.309 102.195 129.972 99.1156 128.433 96.4236C127.186 94.2227 124.654 94.3077 122.066 95.0445C120.857 95.4104 119.671 95.8488 118.515 96.3575C119.667 95.2334 120.867 94.1471 122.076 93.0798C123.672 91.7196 125.316 90.4066 126.988 89.1314C128.791 90.5668 130.877 91.6064 133.108 92.1824C137.34 93.2309 140.004 90.1516 138.474 87.4595C137.227 85.2586 134.695 85.3531 132.107 86.0899C131.512 86.2599 130.908 86.4677 130.322 86.6849C132.532 85.1075 134.78 83.5678 137.028 82.0281L139.107 80.6113C140.983 82.1756 143.183 83.3046 145.549 83.9173C149.79 84.9658 152.444 81.8865 150.914 79.1944C149.667 76.9841 147.136 77.0785 144.547 77.8153C143.542 78.1111 142.555 78.4644 141.591 78.8732C142.025 78.571 142.45 78.2593 142.875 77.9287C143.669 77.3619 144.443 76.7857 145.218 76.1906C146.163 75.4727 147.107 74.6699 148.052 73.9142C148.581 73.4891 149.091 73.0357 149.601 72.5729C151.475 74.1656 153.688 75.3092 156.071 75.9167C160.312 76.9652 162.976 73.8953 161.446 71.1938C160.199 68.9929 157.668 69.0779 155.07 69.8147C153.65 70.2528 152.259 70.7797 150.904 71.3921C152.633 69.7864 154.305 68.1145 155.892 66.367C156.005 66.2442 156.1 66.1214 156.204 65.9986C156.893 65.2429 157.564 64.4778 158.215 63.6938C158.867 62.9098 159.698 61.8046 160.416 60.8601C163.326 57.0453 165.717 52.8622 167.529 48.4199C165.638 52.8246 163.163 56.9549 160.171 60.6995C157.224 64.4584 153.935 67.9367 150.347 71.0899L149.96 71.4205C150.781 70.0066 151.507 68.5392 152.132 67.0282C153.077 64.6478 153.266 62.258 150.989 60.9734C148.156 59.4054 144.793 61.748 145.7 65.7908C146.277 68.1677 147.428 70.3667 149.053 72.195L148.212 72.9129C147.882 73.1869 147.542 73.4702 147.202 73.7347C146.644 74.1881 146.078 74.6226 145.511 75.0477L144.566 75.7467C143.754 76.3418 142.923 76.9369 142.091 77.513L140.797 78.3065L139.437 79.2511C140.228 77.8929 140.926 76.4822 141.525 75.0288C142.469 72.6484 142.658 70.2587 140.382 68.974C137.548 67.3966 134.185 69.7486 135.083 73.7914C135.643 76.0924 136.744 78.2264 138.294 80.0162L137.284 80.6679L133.505 83.105L132.778 83.5867C132.079 84.0401 131.389 84.5313 130.7 84.9752C130.398 85.1736 130.095 85.372 129.802 85.5798C128.858 86.241 127.866 86.9116 126.912 87.6012C127.714 86.22 128.424 84.7875 129.037 83.3128C129.982 80.9324 130.171 78.5332 127.894 77.258C125.061 75.6806 121.698 78.0326 122.595 82.0659C123.161 84.4033 124.286 86.5685 125.873 88.3757C124.248 89.5659 122.643 90.7939 121.075 92.0691C119.941 93.0136 118.817 94.0149 117.721 95.0162C118.199 94.1319 118.625 93.2204 118.996 92.2863C119.941 89.906 120.13 87.5634 117.853 86.2315C115.02 84.6635 111.657 87.0061 112.554 91.0489C113.091 93.2602 114.129 95.3187 115.586 97.0659C112.485 100.146 109.692 103.522 107.246 107.145C107.526 106.102 107.737 105.041 107.879 103.971C108.19 101.439 107.822 99.059 105.309 98.3694C102.211 97.5193 99.4814 100.618 101.333 104.32C102.395 106.353 103.915 108.112 105.772 109.459C103.366 113.388 101.353 117.545 99.7647 121.871C99.7249 120.966 99.6335 120.064 99.4908 119.169C99.0658 116.657 98.0456 114.446 95.4386 114.531C92.227 114.588 90.4889 118.31 93.3132 121.361C94.8214 122.93 96.6608 124.144 98.6974 124.912C97.6097 128.261 96.7202 131.67 96.0336 135.123C95.9297 135.671 95.8353 136.219 95.7408 136.767C95.6185 136.864 95.5048 136.971 95.4008 137.088C95.2874 136.616 95.1552 136.143 95.0041 135.68C94.1917 133.262 92.8504 131.269 90.2811 131.723C87.1168 132.28 85.9833 136.247 89.2327 138.798C90.8886 140.065 92.7996 140.957 94.834 141.414C94.8637 141.508 94.9016 141.6 94.9474 141.688C94.5979 144.286 94.3334 146.893 94.1728 149.519C94.0532 151.471 93.9745 153.432 93.9367 155.403C91.1974 155.403 89.2138 158.398 91.1596 161.656C91.9511 163.006 92.9669 164.21 94.1634 165.217C94.3995 168.901 94.7585 172.585 95.2496 176.241C94.8624 175.883 94.3884 175.634 93.8748 175.516C93.3611 175.398 92.8256 175.417 92.3214 175.57C90.5928 176.033 89.8183 177.459 89.5444 179.131C88.9423 179.767 88.6046 180.608 88.5998 181.483C87.3152 179.594 86.1061 177.62 84.9348 175.636C86.7285 174.258 88.2148 172.521 89.2988 170.535C91.358 166.691 89.0437 163.347 86.04 164.169C83.5935 164.83 83.0551 167.324 83.1307 169.997C83.1718 171.009 83.2664 172.018 83.414 173.02L82.2333 170.724C81.1754 168.835 80.278 166.946 79.2862 164.981C79.0312 164.518 78.8139 164.037 78.6061 163.555C80.625 162.539 82.4104 161.114 83.8485 159.371C86.5878 155.979 84.9348 152.258 81.8366 152.503C79.3051 152.692 78.3133 155.044 77.8882 157.68C77.7166 158.831 77.6126 159.992 77.5765 161.156L76.6319 159.078C74.7131 154.37 73.1348 149.531 71.909 144.597C74.1826 143.797 76.2528 142.507 77.9732 140.819C81.0431 137.711 79.7774 133.848 76.6603 133.772C74.1288 133.716 72.8819 135.954 72.2113 138.495C71.8733 139.883 71.621 141.29 71.4556 142.708C70.785 139.874 70.2088 137.041 69.7365 134.141C69.4059 132.355 69.1981 130.551 68.9714 128.747C71.4292 128.271 73.7437 127.233 75.7346 125.715C79.1823 123.042 78.4172 119.046 75.3379 118.565C72.8442 118.177 71.3328 120.236 70.3127 122.711C69.7157 124.281 69.2172 125.887 68.8202 127.519C68.6219 125.422 68.4046 123.335 68.3102 121.238C68.0362 116.909 68.0551 112.567 68.3668 108.24C67.9229 112.564 67.7714 116.913 67.9134 121.257C67.9134 123.259 68.0835 125.252 68.2063 127.255C67.6702 125.893 67.039 124.57 66.3171 123.297C65.0136 121.106 63.2661 119.452 60.8574 120.463C57.882 121.682 57.6269 125.81 61.3486 127.604C63.5426 128.609 65.9478 129.066 68.3574 128.936C68.5274 130.721 68.6786 132.507 68.943 134.273C69.3209 137.107 69.8026 139.94 70.3599 142.689C69.7515 141.622 69.0731 140.597 68.3291 139.619C66.7422 137.617 64.8058 136.2 62.5388 137.494C59.705 139.09 60.0262 143.209 63.9556 144.503C66.1823 145.198 68.5419 145.357 70.8416 144.966C71.9251 149.957 73.3613 154.866 75.1395 159.654L75.7062 161.09C75.1962 160.438 74.6483 159.767 74.0721 159.201C72.2963 157.368 70.2277 156.159 68.1024 157.67C65.4859 159.559 66.2132 163.612 70.2088 164.509C72.4452 164.965 74.7567 164.897 76.9625 164.311C77.1609 164.802 77.3593 165.255 77.5954 165.775C78.54 167.74 79.409 169.761 80.4291 171.697C80.7125 172.255 81.0053 172.802 81.2982 173.35C80.7975 172.925 80.278 172.51 79.7396 172.132C77.6615 170.658 75.3945 169.855 73.5904 171.745C71.3801 174.068 72.8158 177.941 76.9531 178.064C79.0835 178.092 81.1947 177.657 83.1401 176.789C84.3208 178.933 85.5488 181.049 86.8617 183.127C87.3529 183.92 87.863 184.704 88.3731 185.488C87.6235 184.789 86.8317 184.136 86.0022 183.533C83.9147 182.059 81.6477 181.256 79.853 183.146C77.6332 185.469 79.069 189.342 83.2062 189.465C85.5719 189.493 87.9101 188.955 90.0261 187.897C90.7062 188.841 91.4146 189.786 92.1514 190.731C90.6117 192.516 91.1124 195.548 94.2389 196.889C95.7728 197.524 97.407 197.882 99.0658 197.947C99.2547 198.108 99.453 198.259 99.6514 198.401L99.7553 198.476C100.483 201.197 101.276 203.898 102.107 206.581H88.0897V251.08H123.19V206.552H106.84C105.432 201.744 104.252 197.56 104.006 197.447L103.515 197.21C105.357 196.58 107.069 195.62 108.568 194.377C111.893 191.543 110.949 187.585 107.86 187.255C105.338 186.971 103.921 189.096 103.024 191.619C102.765 192.337 102.544 193.068 102.362 193.81C102.183 193.139 102.003 192.469 101.833 191.798C101.323 189.814 100.889 187.812 100.417 185.819C102.417 185.178 104.275 184.155 105.886 182.806C109.211 179.972 108.266 176.023 105.177 175.683C102.655 175.41 101.248 177.573 100.341 180.047C100.08 180.779 99.8564 181.523 99.6703 182.277C99.3775 180.822 99.1035 179.367 98.8485 177.903C98.6596 176.807 98.4896 175.721 98.329 174.635C98.2629 173.086 98.244 171.527 98.2629 169.978C98.2629 169.119 98.2629 168.268 98.3384 167.409C100.212 168.015 102.182 168.268 104.148 168.155C108.512 167.872 110.117 164.141 107.841 162.015C105.952 160.296 103.581 161.146 101.352 162.62C100.365 163.302 99.4193 164.04 98.5179 164.83C98.7856 161.177 99.3415 157.552 100.18 153.986C100.678 151.895 101.289 149.833 102.013 147.809C104.015 148.501 106.132 148.796 108.247 148.678C112.602 148.404 114.217 144.663 111.94 142.548C110.051 140.819 107.68 141.678 105.451 143.152C104.66 143.689 103.897 144.266 103.165 144.881C104.005 142.903 104.983 140.987 106.093 139.147C108.319 135.444 111.104 132.108 114.349 129.257C116.021 130.789 117.993 131.956 120.139 132.686C124.296 134.046 127.177 131.175 125.807 128.36C124.73 126.074 122.18 125.97 119.554 126.471C118.561 126.691 117.581 126.963 116.616 127.283H116.682C120.244 124.497 124.084 122.085 128.14 120.085C129.576 121.961 131.399 123.504 133.486 124.61C137.369 126.612 140.675 124.251 139.815 121.257C139.116 118.82 136.613 118.319 133.94 118.423C132.892 118.481 131.848 118.598 130.813 118.772C135.13 116.732 139.532 114.805 143.782 112.557L143.877 112.51C145.787 114.151 148.05 115.33 150.489 115.958C154.73 117.006 157.394 113.927 155.854 111.235C154.617 109.024 152.076 109.119 149.488 109.856C148.77 110.054 148.061 110.318 147.362 110.583C150.197 108.932 152.946 107.138 155.599 105.208L155.826 105.444C155.821 105.41 155.821 105.375 155.826 105.34C157.734 106.996 159.996 108.191 162.438 108.835C166.679 109.874 169.343 106.805 167.812 104.112C166.66 101.921 164.11 101.921 161.578 102.696ZM94.6545 189.418C93.795 188.407 92.9637 187.349 92.1609 186.282C92.3592 186.102 92.567 185.904 92.7748 185.696C93.9698 186.072 95.2077 186.294 96.4587 186.357V186.556L97.0443 186.442C97.3466 187.944 97.6678 189.455 97.9889 190.957C97.5952 190.445 97.0821 190.037 96.4943 189.768C95.9064 189.5 95.2618 189.38 94.6168 189.418H94.6545ZM97.7811 153.391C97.4883 154.515 97.2333 155.649 96.9971 156.782L96.8554 156.584C96.8554 154.254 96.8901 151.927 96.9593 149.604C97.0255 147.969 97.1483 146.345 97.2899 144.729C98.0699 145.535 98.9345 146.254 99.8686 146.874C99.0425 149.006 98.333 151.182 97.7433 153.391H97.7811ZM101.711 142.67C101.711 142.245 101.805 141.811 101.833 141.395C101.833 141.178 101.833 140.961 101.833 140.753C102.173 140.649 102.523 140.526 102.872 140.384C102.438 141.14 102.07 141.896 101.673 142.67H101.711ZM106.689 134.575C106.522 134.198 106.282 133.858 105.982 133.576C105.682 133.293 105.328 133.074 104.941 132.932C102.58 131.987 100.662 133.706 99.1413 135.898L99.0658 136.011L98.9146 135.964L98.4234 135.898C98.4234 135.765 98.4707 135.633 98.4896 135.501C99.0971 132.048 99.9141 128.635 100.936 125.281C103.133 125.555 105.363 125.381 107.491 124.77C108.794 124.44 109.933 123.652 110.703 122.551C111.131 124.477 111.933 126.3 113.064 127.916C110.705 129.911 108.556 132.142 106.651 134.575H106.689Z",
    fill: "#0DA06E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M181.095 118.225H349.013C351.017 118.225 352.939 119.021 354.356 120.438C355.774 121.855 356.57 123.777 356.57 125.781V243.608H173.566V125.753C173.574 123.759 174.369 121.848 175.78 120.438C177.19 119.028 179.1 118.232 181.095 118.225Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M383.99 299.027H146.116L173.566 243.599H356.541L383.99 299.027Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M345.461 128.152H184.646V233.672H345.461V128.152Z",
    fill: "#0DA06E",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M257.416 261.14L257.737 254.387H248.064L247.422 261.14H257.416Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M277.404 261.14L277.073 254.387H267.4L267.41 261.14H277.404Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M329.441 268.366H339.775L337.347 261.14H327.363L329.441 268.366Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M247.422 261.14L248.064 254.387H238.401L237.438 261.14H247.422Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M227.445 261.14L228.729 254.387H219.066L217.451 261.14H227.445Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M317.37 261.14L315.745 254.387H306.082L307.376 261.14H317.37Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M327.363 261.14L325.417 254.387H315.744L317.369 261.14H327.363Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M217.451 261.14L219.066 254.387H209.393L207.457 261.14H217.451Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M287.387 261.14L286.735 254.387H277.072L277.403 261.14H287.387Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M337.346 261.14L335.079 254.387H325.416L327.362 261.14H337.346Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M307.375 261.14L306.081 254.387H296.408L297.381 261.14H307.375Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M297.382 261.14L296.409 254.387H286.736L287.388 261.14H297.382Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M267.41 261.14L267.4 254.387H257.737L257.416 261.14H267.41Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M197.474 261.14H187.48L184.722 268.366H195.055L197.474 261.14Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M199.721 254.387H190.058L187.479 261.14H197.473L199.721 254.387Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M207.458 261.14L209.394 254.387H199.722L197.474 261.14H207.458Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M181.765 276.103L178.582 284.415H189.69L192.467 276.103H181.765Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M195.055 268.366H184.721L181.765 276.102H192.467L195.055 268.366Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M192.467 276.103L189.689 284.415H200.798L203.178 276.103H192.467Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M237.439 261.14L238.402 254.387H228.73L227.445 261.14H237.439Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M236.4 268.366L237.439 261.14H227.446L226.066 268.366H236.4Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M226.066 268.366L227.445 261.14H217.452L215.732 268.366H226.066Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M246.742 268.366L247.422 261.14H237.437L236.398 268.366H246.742Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M207.457 261.14H197.473L195.055 268.366H205.388L207.457 261.14Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M331.671 276.102H342.382L339.775 268.366H329.441L331.671 276.102Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M215.732 268.366L217.451 261.14H207.457L205.389 268.366H215.732Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M195.055 268.366L192.467 276.102H203.178L205.389 268.366H195.055Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M308.763 268.366L307.375 261.14H297.381L298.429 268.366H308.763Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M298.431 268.366L297.382 261.14H287.389L288.088 268.366H298.431Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M329.441 268.366L327.363 261.14H317.369L319.098 268.366H329.441Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M267.419 268.366L267.41 261.14H257.416L257.076 268.366H267.419Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M288.088 268.366L287.389 261.14H277.404L277.754 268.366H288.088Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M277.753 268.366L277.404 261.14H267.41L267.42 268.366H277.753Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M257.076 268.366L257.416 261.14H247.422L246.742 268.366H257.076Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M288.086 268.366L288.842 276.102H299.544L298.429 268.366H288.086Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M298.43 268.366L299.544 276.102H310.256L308.763 268.366H298.43Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M205.388 268.366L203.178 276.102H213.889L215.731 268.366H205.388Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M308.764 268.366L310.256 276.102H320.958L319.097 268.366H308.764Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M267.42 268.366V276.102H278.132L277.754 268.366H267.42Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M319.098 268.366L320.958 276.102H331.67L329.441 268.366H319.098Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M277.754 268.366L278.132 276.102H288.843L288.088 268.366H277.754Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M226.065 268.366L224.592 276.102H235.303L236.399 268.366H226.065Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M215.733 268.366L213.891 276.102H224.593L226.066 268.366H215.733Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M257.076 268.366L256.717 276.102H267.419V268.366H257.076Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M246.743 268.366L246.006 276.102H256.717L257.076 268.366H246.743Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M236.398 268.366L235.303 276.102H246.005L246.742 268.366H236.398Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M319.097 268.366L317.369 261.14H307.375L308.764 268.366H319.097Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M199.722 254.386L202.036 247.472H192.694L190.059 254.386H199.722Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M190.058 254.387H181.132L178.251 261.14H187.48L190.058 254.387Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M192.694 247.472H184.079L181.132 254.386H190.058L192.694 247.472Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M187.479 261.14H178.251L175.181 268.366H184.721L187.479 261.14Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M184.721 268.366H175.181L171.875 276.102H181.765L184.721 268.366Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M181.765 276.103H171.875L168.333 284.415H178.582L181.765 276.103Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M347.34 261.14L350.117 268.366H359.26L356.181 261.14H347.34Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M353.083 276.102H362.557L359.261 268.366H350.117L353.083 276.102Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M356.277 284.415H366.1L362.558 276.103H353.084L356.277 284.415Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M277.073 254.386L276.733 247.472H267.4V254.386H277.073Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M347.34 261.14H356.181L353.3 254.387H344.752L347.34 261.14Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M342.382 276.102H353.085L350.119 268.366H339.775L342.382 276.102Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M209.394 254.386L211.368 247.472H202.036L199.722 254.386H209.394Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M335.08 254.387L337.347 261.14H347.341L344.753 254.387H335.08Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M353.3 254.386L350.353 247.472H342.098L344.752 254.386H353.3Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M344.752 254.386L342.098 247.472H332.756L335.08 254.386H344.752Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M310.256 276.103L311.852 284.415H322.96L320.958 276.103H310.256Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M345.167 284.415H356.276L353.083 276.103H342.381L345.167 284.415Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M335.08 254.386L332.756 247.472H323.424L325.417 254.386H335.08Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M331.67 276.103L334.069 284.415H345.168L342.381 276.103H331.67Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M320.959 276.103L322.961 284.415H334.07L331.671 276.103H320.959Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M339.775 268.366H350.118L347.341 261.14H337.348L339.775 268.366Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M248.065 254.386L248.727 247.472H239.385L238.402 254.386H248.065Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M325.417 254.386L323.424 247.472H314.082L315.744 254.386H325.417Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M238.403 254.386L239.385 247.472H230.053L228.73 254.386H238.403Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M267.401 254.386V247.472H258.059L257.738 254.386H267.401Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M228.729 254.386L230.052 247.472H220.71L219.066 254.386H228.729Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M219.067 254.386L220.711 247.472H211.369L209.395 254.386H219.067Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M257.737 254.386L258.058 247.472H248.726L248.064 254.386H257.737Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M315.745 254.386L314.082 247.472H304.75L306.082 254.386H315.745Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M306.082 254.386L304.75 247.472H295.408L296.409 254.386H306.082Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M286.736 254.386L286.074 247.472H276.732L277.072 254.386H286.736Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M310.256 276.103H299.544H288.842H278.131H267.419H256.717H246.006H235.303H224.592H213.89H203.178L200.798 284.415H211.906H223.005H234.113H245.222H256.33H267.429H278.537H289.645H300.744H311.852L310.256 276.103Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M296.408 254.386L295.407 247.472H286.074L286.735 254.386H296.408Z",
    fill: "#263238",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M384.094 299.018H146.116V302.39H384.094V299.018Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M328.685 152.22V242.985L302.303 277.377L297.863 279.039L162.524 299.008V303.447L112.952 306.111V257.408H197.473V151.785L328.685 152.22Z",
    fill: "black"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5552 247.669C76.4626 247.972 69.86 252.619 69.86 252.619L1 306.111H112.952C112.952 306.111 183.635 252.77 185.751 251.24C189.104 248.822 195.754 247.594 195.754 247.594L192.608 247.669H82.5552Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M340.105 152.305H190.285",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M317.511 120.019C316.042 120.017 314.588 120.306 313.231 120.868C311.874 121.429 310.641 122.253 309.603 123.292C308.565 124.331 307.742 125.564 307.182 126.922C306.621 128.279 306.334 129.734 306.336 131.202V268.554C306.333 270.366 305.895 272.15 305.06 273.757C304.225 275.365 303.017 276.749 301.537 277.793C300.056 278.837 298.348 279.512 296.553 279.76C294.759 280.008 292.931 279.822 291.223 279.218L206.466 249.115C202.02 247.531 197.213 247.262 192.618 248.34V131.202C192.618 128.239 193.795 125.397 195.891 123.301C197.987 121.205 200.829 120.028 203.793 120.028L317.511 120.019Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3342_24659",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 120,
    width: 126,
    height: 160
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M317.511 120.019C316.042 120.017 314.588 120.306 313.231 120.868C311.874 121.429 310.641 122.253 309.603 123.292C308.565 124.331 307.742 125.564 307.182 126.922C306.621 128.279 306.334 129.734 306.336 131.202V268.554C306.333 270.366 305.895 272.15 305.06 273.757C304.225 275.365 303.017 276.749 301.537 277.793C300.056 278.837 298.348 279.512 296.553 279.76C294.759 280.008 292.931 279.822 291.223 279.218L206.466 249.115C202.02 247.531 197.213 247.262 192.618 248.34V131.202C192.618 128.239 193.795 125.397 195.891 123.301C197.987 121.205 200.829 120.028 203.793 120.028L317.511 120.019Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3342_24659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.875 252.817L291.214 279.218C292.921 279.822 294.749 280.008 296.544 279.76C298.338 279.512 300.047 278.838 301.527 277.793C303.007 276.749 304.215 275.365 305.051 273.757C305.886 272.15 306.323 270.366 306.327 268.554V252.817H216.875Z",
    fill: "#0DA06E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M216.875 252.817L291.214 279.218C292.921 279.822 294.749 280.008 296.544 279.76C298.338 279.512 300.047 278.838 301.527 277.793C303.007 276.749 304.215 275.365 305.051 273.757C305.886 272.15 306.323 270.366 306.327 268.554V252.817H216.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.875 270.906L291.214 297.355C292.922 297.959 294.751 298.144 296.546 297.896C298.341 297.647 300.051 296.972 301.531 295.927C303.011 294.881 304.219 293.496 305.054 291.887C305.888 290.278 306.325 288.493 306.327 286.681V270.906H216.875Z",
    fill: "#0DA06E"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M317.511 120.019C316.042 120.017 314.588 120.306 313.231 120.868C311.874 121.429 310.641 122.253 309.603 123.292C308.565 124.331 307.742 125.564 307.182 126.922C306.621 128.279 306.334 129.734 306.336 131.202V268.554C306.333 270.366 305.895 272.15 305.06 273.757C304.225 275.365 303.017 276.749 301.537 277.793C300.056 278.838 298.348 279.512 296.553 279.76C294.759 280.008 292.931 279.822 291.223 279.218L206.466 249.115C202.02 247.531 197.213 247.262 192.618 248.34V131.202C192.618 128.239 193.795 125.397 195.891 123.301C197.987 121.205 200.829 120.028 203.793 120.028L317.511 120.019Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M197.426 247.669H192.608",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M295.02 279.889H181.292C180.004 279.883 178.726 279.656 177.514 279.218L157.876 272.313L182.293 253.516C185.59 250.737 189.556 248.869 193.798 248.097C198.04 247.325 202.41 247.676 206.475 249.114L291.232 279.218C292.447 279.657 293.728 279.884 295.02 279.889Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3342_24659",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 247,
    width: 139,
    height: 33
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M295.02 279.889H181.292C180.004 279.883 178.726 279.656 177.514 279.218L157.876 272.313L182.293 253.516C185.59 250.737 189.556 248.869 193.798 248.097C198.04 247.325 202.41 247.676 206.475 249.114L291.232 279.218C292.447 279.657 293.728 279.884 295.02 279.889Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3342_24659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.02 279.889H181.292C180.003 279.883 178.725 279.656 177.514 279.218L156.657 271.945L182.274 253.516C185.571 250.737 189.537 248.869 193.779 248.097C198.021 247.325 202.391 247.676 206.456 249.114L291.213 279.218C292.434 279.659 293.722 279.886 295.02 279.889Z",
    fill: "#0DA06E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M295.02 279.889H181.292C180.003 279.883 178.725 279.656 177.514 279.218L156.657 271.945L182.274 253.516C185.571 250.737 189.537 248.869 193.779 248.097C198.021 247.325 202.391 247.676 206.456 249.114L291.213 279.218C292.434 279.659 293.722 279.886 295.02 279.889Z",
    fill: "black"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M295.02 279.889H181.292C180.004 279.883 178.726 279.656 177.514 279.218L157.876 272.313L182.293 253.516C185.59 250.737 189.556 248.869 193.798 248.097C198.04 247.325 202.41 247.676 206.475 249.114L291.232 279.218C292.447 279.657 293.728 279.884 295.02 279.889Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M181.292 279.889H181.047",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M295.237 279.889H295.02",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M325.408 123.296C324.374 122.255 323.143 121.428 321.788 120.866C320.432 120.303 318.979 120.015 317.511 120.019C305.874 120.019 306.336 131.193 306.336 131.193V152.219H328.685V131.202C328.689 129.733 328.401 128.278 327.838 126.921C327.276 125.564 326.45 124.332 325.408 123.296Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3342_24659",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 306,
    y: 120,
    width: 23,
    height: 33
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M325.408 123.296C324.374 122.255 323.143 121.428 321.788 120.866C320.432 120.303 318.979 120.015 317.511 120.019C305.874 120.019 306.336 131.193 306.336 131.193V152.219H328.685V131.202C328.689 129.733 328.401 128.278 327.838 126.921C327.276 125.564 326.45 124.332 325.408 123.296Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3342_24659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.408 123.296C324.374 122.255 323.143 121.428 321.788 120.866C320.432 120.303 318.979 120.015 317.511 120.019C305.874 120.019 306.336 131.193 306.336 131.193V152.219H328.685V131.202C328.689 129.733 328.401 128.278 327.838 126.921C327.276 125.564 326.45 124.332 325.408 123.296Z",
    fill: "#0DA06E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M325.408 123.296C324.374 122.255 323.143 121.428 321.788 120.866C320.432 120.303 318.979 120.015 317.511 120.019C305.874 120.019 306.336 131.193 306.336 131.193V152.219H328.685V131.202C328.689 129.733 328.401 128.278 327.838 126.921C327.276 125.564 326.45 124.332 325.408 123.296Z",
    fill: "black"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M325.408 123.296C324.374 122.255 323.143 121.428 321.788 120.866C320.432 120.303 318.979 120.015 317.511 120.019C305.874 120.019 306.336 131.193 306.336 131.193V152.219H328.685V131.202C328.689 129.733 328.401 128.278 327.838 126.921C327.276 125.564 326.45 124.332 325.408 123.296Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.047 139.269V139.467V144.237V144.435V149.206V149.404V154.165V154.363V159.133V159.332V164.102V164.3V169.061V169.259V174.029V174.228V178.998V179.196V183.957V184.155V188.925V189.124V194.092H213.843V189.124V188.925V184.155V183.957V179.196V178.998V174.228V174.029V169.259V169.061V164.3V164.102V159.332V159.133V154.363V154.165V149.404V149.206V144.435V144.237V139.467V139.269V134.31H203.047V139.269Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.172 134.31H287.945H277.611H277.375H267.042H266.805H256.481H256.245H245.911H245.675H235.351H235.115H224.781H224.545H213.984V139.467H224.545H224.781H235.115H235.351H245.675H245.911H256.245H256.481H266.805H267.042H277.375H277.611H287.945H288.172H298.742V134.31H288.172Z",
    fill: "black"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 134.31H203.047V139.476H213.843V134.31Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 139.269H203.047V144.435H213.843V139.269Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 144.237H203.047V149.404H213.843V144.237Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 149.206H203.047V154.373H213.843V149.206Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 154.165H203.047V159.332H213.843V154.165Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 159.134H203.047V164.301H213.843V159.134Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 164.102H203.047V169.268H213.843V164.102Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 169.061H203.047V174.227H213.843V169.061Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 174.029H203.047V179.196H213.843V174.029Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 178.998H203.047V184.165H213.843V178.998Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 183.957H203.047V189.124H213.843V183.957Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M213.843 188.926H203.047V194.093H213.843V188.926Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M224.781 134.31H213.984V139.476H224.781V134.31Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M235.341 134.31H224.545V139.476H235.341V134.31Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M245.912 134.31H235.115V139.476H245.912V134.31Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M256.472 134.31H245.676V139.476H256.472V134.31Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M267.041 134.31H256.244V139.476H267.041V134.31Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M277.601 134.31H266.805V139.476H277.601V134.31Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M288.172 134.31H277.375V139.476H288.172V134.31Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M298.742 134.31H287.945V139.476H298.742V134.31Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M298.731 139.467H213.842V194.083H298.731V139.467Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M224.639 139.467V194.073",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M235.209 139.467V194.073",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M245.779 139.467V194.073",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M256.35 139.467V194.073",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M266.91 139.467V194.073",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M277.479 139.467V194.073",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M288.049 139.467V194.073",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M213.842 144.436H298.675",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M213.842 149.386H298.675",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M213.842 154.335H298.675",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M213.842 159.284H298.675",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M213.842 164.234H298.675",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M213.842 169.175H298.675",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M213.842 174.124H298.675",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M213.842 179.074H298.675",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M213.842 184.023H298.675",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M213.842 188.973H298.675",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M159.727 260.968H68.7168L74.9983 256.198H166.009L159.727 260.968Z",
    fill: "#0DA06E"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5525 299.262H18.3232L74.9981 256.198H77.2368L20.5525 299.262Z",
    fill: "#0DA06E"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M139.674 276.176H48.6729L55.7856 270.849H146.787L139.674 276.176Z",
    fill: "#263238"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M109.042 299.479H18.0312L74.999 256.198H166.009L109.042 299.479Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3784 256.359L27.6562 299.451",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5219 256.359L36.7998 299.451",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M102.656 256.359L45.9336 299.451",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M111.799 256.359L55.0771 299.451",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M120.943 256.359L64.2207 299.451",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M130.086 256.359L73.3545 299.451",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M139.22 256.359L82.498 299.451",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M148.365 256.359L91.6426 299.451",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M157.508 256.359L100.776 299.451",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1436 265.323H153.88",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8994 270.83H146.636",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6543 276.337H139.391",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4092 281.835H132.146",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1641 287.342H124.901",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9189 292.849H117.655",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M298.883 198.258H202.961V201.781H298.883V198.258Z",
    fill: "#0DA06E"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M205.313 198.258H202.961V243.636H205.313V198.258Z",
    fill: "#0DA06E"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M298.883 198.258H202.961V243.872H298.883V198.258Z",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M213.068 198.428V243.843",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M222.703 198.428V243.843",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M232.338 198.428V243.843",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M241.973 198.428V243.843",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M251.607 198.428V243.843",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M261.242 198.428V243.843",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M270.877 198.428V243.843",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M280.502 198.428V243.843",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M290.137 198.428V243.843",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M203.121 207.874H298.76",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M203.121 213.684H298.76",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M203.121 219.483H298.76",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M203.121 225.282H298.76",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M203.121 231.082H298.76",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M203.121 236.882H298.76",
    stroke: "#263238",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.7aadb3d4bb276bcc5c8aa5b16bbc82a6.svg";
export { ForwardRef as ReactComponent };